import React, { useState, useEffect, createContext } from "react";

// Theme Context
export const ThemeContext = createContext();

// Theme Provider Component
export const ThemeProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(() => {
        // Check localStorage or system preference
        const savedTheme = localStorage.getItem("workout-tracker-theme");
        if (savedTheme) {
            return savedTheme === "dark";
        }
        // Default to system preference
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    });

    useEffect(() => {
        // Save to localStorage
        localStorage.setItem("workout-tracker-theme", darkMode ? "dark" : "light");

        // Apply theme to document
        if (darkMode) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [darkMode]);

    const toggleTheme = () => {
        setDarkMode((prev) => !prev);
    };

    const value = {
        darkMode,
        toggleTheme,
    };

    return (
        <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    );
};
